var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tabella-download-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabella-download-over"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "#4E565A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.36666667,0 0,5.36666667 0,12 C0,18.6333333 5.36666667,24 12,24 C18.6333333,24 24,18.6333333 24,12 C24,5.36666667 18.6333333,0 12,0",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.484859,16.58675 L12.8820138,19.3537351 C12.7955455,19.4113806 12.7090772,19.4690262 12.6226089,19.4978489 L12.5937862,19.4978489 C12.4208496,19.5843172 12.2190903,19.6419627 12.017331,19.6419627 C11.7579261,19.6419627 11.4696985,19.5554944 11.2391164,19.3825579 L7.5209802,16.58675 C6.94452497,16.1544086 6.82923393,15.3473713 7.26157534,14.7709161 C7.69391676,14.1944608 8.50095408,14.0791698 9.0774093,14.5115112 L10.6914839,15.7220672 L10.6626612,6.29702426 C10.6626612,5.57645523 11.2391164,5 11.9596854,5 C12.6802545,5 13.2567097,5.57645523 13.2567097,6.29702426 L13.2855325,15.75089 L14.8996071,14.5115112 C15.4760623,14.0791698 16.2830996,14.1944608 16.715441,14.7420933 C17.1766052,15.3185485 17.0613142,16.1544086 16.484859,16.58675",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOver);
export default __webpack_public_path__ + "static/media/download-over.d800e67766f9a1cf593fc6f7a21c13d2.svg";
export { ForwardRef as ReactComponent };